import { http } from "../../../config/HttpMethod";
import { ESP_ENDPOINTS } from "../endpoints";

export const loadProtectorSeries = async (casingOD: number) => {
    const params = { casingSize: casingOD };
    const response = await http.get(`${ESP_ENDPOINTS?.GET_PROTECTOR_SERIES}`, {
        params,
    });
    return response.data;
};


export const loadProtectorList = async (payload: any) => {
    const {
        casingOD,
        UnitSytm,
        MotrSers,
        catalogFilter
    } = payload;
    const params = { casingSize: casingOD, UnitSytm: UnitSytm, MotrSers: MotrSers, catalogFilter: catalogFilter };
    const response = await http.get(`${ESP_ENDPOINTS?.GET_PROTECTOR_LIST}`, {
        params,
    });
    return response.data;
};


export const loadOilContraction = async (params: (string | number)[]) => {
    const response = await http.post(`${ESP_ENDPOINTS?.GET_PROTECTOR_OIL_CONTRACTION}`, params);
    return response.data;
}

export const loadProtectorCalculations = async (payload: any) => {
    let params = {
        PMax: payload[0],
        ShaftDia: payload[1],
        ProtctrID: payload[2],
        BearngTyp: payload[3],
        UnitSystm: payload[4],
        PmpID: payload[5],
        NoOfStages: payload[6],
        LiqPhase: payload[7],
        ShaftType: payload[8],
        LiqPhseUnit: payload[9],
    };
    const response = await http.get(`${ESP_ENDPOINTS?.GET_PROTECTOR_CALCULATIONS}`, {
        params,
    });
    return response.data;
}

export const loadEquipments = async (catalogFilter: number) => {
    const params = { 'catalogFilter': catalogFilter };
    const response = await http.get(`${ESP_ENDPOINTS?.GET_SR_PROTECTORS}`, {
        params
    });
    return response.data;
}